/**
 * engine/premissas.ts — premissas macro (ex-global `PREMISSAS` do protótipo).
 *
 * No v67 (linhas 1328-1332) `PREMISSAS` é objeto GLOBAL MUTÁVEL, sobrescrito pelo
 * localStorage em `carregarSalvo` (linha 1644). Aqui não existe global: os valores viram
 * `PREMISSAS_PADRAO` (defaults idênticos) e são passados por PARÂMETRO para quem precisa.
 *
 * Quem lê premissas no motor: só `calcBase`, e só `desp` (faixas lim/limErr).
 * `faixaLGC` e `sugFin` não alimentam cálculo.
 */

import type { FaixaPerfil, Funding, PremissasMacro, Rating } from './tipos';

/** Cópia literal de `PREMISSAS` (v67 linhas 1328-1332). */
export const PREMISSAS_PADRAO: PremissasMacro = {
  lgc: {
    'AA': { FGTS: [8, 10], SBPE: [9, 11], Mercado: [10, 12] },
    'A': { FGTS: [9, 11], SBPE: [10, 12], Mercado: [11, 13] },
    'B': { FGTS: [10, 12], SBPE: [11, 13], Mercado: [12, 14] },
    'C': { FGTS: [11, 13], SBPE: [12, 14], Mercado: [14, 16] },
    'D': { FGTS: [12, 14], SBPE: [14, 16], Mercado: [16, 18] },
  },
  desp: { dfMin: 0.5, dfMax: 5, dcMin: 4, dcMax: 8, segMax: 0.5, legMax: 2 },
  perfil: [
    { ate: 200000, p: 80 },
    { ate: 350000, p: 78 },
    { ate: 500000, p: 75 },
    { ate: 800000, p: 70 },
    { ate: null, p: 65 },
  ],
};

/** v67 linha 1335. Existe no protótipo mas NÃO é usado por ninguém — o 1.30 de `calcIGH`
 *  e de `calcEstatico` está literal no corpo das funções. Migrado só como registro. */
export const IGH_COEF_EXEMPLO = 1.30;

/**
 * v67 linha 1333, com `PREMISSAS` promovida a parâmetro.
 * ⚠ CÓDIGO MORTO no v67: nenhum chamador (grep confirma só a definição). Migrada porque
 * a tabela de LGC por rating/funding é regra de negócio real que a UI pode voltar a usar.
 */
export function faixaLGC(premissas: PremissasMacro, r: Rating, f: Funding): [number, number] {
  const x = premissas.lgc[r] || premissas.lgc['A'];
  return x[f] || x['SBPE'];
}

/**
 * v67 linha 1334, com `PREMISSAS.perfil` promovido a parâmetro.
 * % de financiamento SUGERIDO pelo preço médio. Usada só no render das tabelas
 * EL-147/EL-154 (sugestão); não alimenta cálculo.
 */
export function sugFin(perfil: FaixaPerfil[], preco: number): number {
  if (!preco) return 75;
  const f = perfil.find(x => x.ate == null || preco < x.ate);
  return f ? f.p : 65;
}
